import type { HistoryEvent } from '@/entities/database';

export interface HistoryGroup {
  key: string;
  events: HistoryEvent[];
}

/**
 * Entries of one operation (several cells of one request, an import or a copy with its batches)
 * sit together; everything else stays one by one. Newest first, as received. Grouping looks only
 * at neighbours, so a page boundary never hides an entry - when the next page arrives, the group
 * simply grows.
 */
export function groupByOperation(events: readonly HistoryEvent[]): HistoryGroup[] {
  const groups: HistoryGroup[] = [];
  for (const event of events) {
    const last = groups.at(-1);
    const operation = event.operation_id;
    if (operation !== null && last?.events[0]?.operation_id === operation) {
      last.events.push(event);
    } else {
      groups.push({ key: event.id, events: [event] });
    }
  }
  return groups;
}

/** The entry that names the whole operation (the import / copy itself), if there is one. */
const OPERATIONS = new Set([
  'database.imported',
  'database.duplicated',
  'table.imported',
  'table.duplicated',
]);
export const mainEvent = (group: HistoryGroup): HistoryEvent | undefined =>
  group.events.find((event) => OPERATIONS.has(event.event_type));
